// extracted by mini-css-extract-plugin
export var searchHeader = "_1z-0";
export var searchHeaderDark = "_1z-1";